import request from '@/utils/request'

export function sendAppAuthCode(params) {
  return request({
    url: '/merchant-api/app/sendAuthCode',
    method: 'get',
    params
  })
}

export function checkAppAuthCode(params) {
  return request({
    url: '/merchant-api/app/checkAuthCode',
    method: 'get',
    params
  })
}

export function fetchMerchantAppList(params) {
  return request({
    url: '/merchant-api/app/getAppInfoList',
    method: 'get',
    params
  })
}

export function addMerchantApp(data) {
  return request({
    url: '/mchApp',
    method: 'post',
    data
  })
}

// 获取回调列表
export function fetchEventList(params) {
  return request({
    url: '/mchApp/events',
    method: 'get',
    params
  })
}

// 更新商户回调事件
export function updateMerchantAppEvent(data) {
  return request({
    url: `/merchant-api/app/updateWebhook`,
    method: 'post',
    data
  })
}

// 获取商户信息
export function fetchMerchantInfo(params) {
  return request({
    url: '/merchant-api/mch/info',
    method: 'get',
    params
  })
}
// 获取提现最低限额
export function getWithdrawThreshold(params) {
  return request({
    url: '/merchant-api/mchWithdraw/getWithdrawThreshold',
    method: 'get',
    params
  })
}
// 根据条件查询商户银行卡列表
export function bankQueryList(params) {
  return request({
    url: '/merchant-api/merchant/bank/bankQueryList',
    method: 'get',
    params
  })
}

// 获取系统开户行接口
export function fetchBankList(params) {
  return request({
    url: '/merchant-api/sysBank/list',
    method: 'get',
    params
  })
}

// 商户提现接口
export function mchWithdraw(data) {
  return request({
    url: '/merchant-api/mchWithdraw/withdrawal',
    method: 'post',
    data
  })
}

// 商户充值接口
export function mchRecharge(data) {
  return request({
    url: '/merchant-api/mch/recharge',
    method: 'post',
    data
  })
}

export function authenticateMfa(data) {
  return request({
    url: '/merchant-api/mch/system/verify',
    method: 'post',
    data
  })
}

export function reSetSecret(data) {
  return request({
    url: '/mchApp/reSet/secret/' + data.id,
    method: 'post',
    data
  })
}

export function reSetPublicSecret(data) {
  return request({
    url: '/merchant-api/app/updatePublicKey',
    method: 'post',
    data
  })
}

export function updateSharePublicConfig(data) {
  return request({
    url: '/merchant-api/app/updateSharePublicConfig',
    method: 'post',
    data
  })
}

export function reSetMchAppWhiteIps(data) {
  return request({
    url: '/merchant-api/app/updateWhiteIps',
    method: 'post',
    data
  })
}

export function fetchMchInstitutePaymentList(params) {
  return request({
    url: '/mchInstitute/payment/plans',
    method: 'get',
    params
  })
}

export function fetchMchInstitutePayoutList(params) {
  return request({
    url: '/mchInstitute/payout/plans',
    method: 'get',
    params
  })
}

// 获取关联商户列表
export function fetchRelateMchsList(params) {
  return request({
    url: '/merchant-api/mch/relateMchList',
    method: 'get',
    params
  })
}

// 商户间转账
export function mchRelateTransfer(data) {
  return request({
    url: '/merchant-api/trade/relate/createTransfer',
    method: 'post',
    data
  })
}

export function updateMchUserHeadImg(data) {
  return request({
    url: '/update/mchUser/headImg',
    method: 'post',
    data
  })
}

export function updateMchLogoImg(data) {
  return request({
    url: '/merchant-api/mch/update-logo',
    method: 'post',
    data
  })
}

// 获取充值信息
export function GetRechargeInfo(params) {
  return request({
    url: '/merchant-api/recharge/mchRechargeInfoDetail',
    method: 'get',
    params
  })
}
